const projectTaskCategoryTypes = {
  standard: { id: 'standard', name: 'Standard' },
  rollup: { id: 'rollup', name: 'Rollup' },
  milestone: { id: 'milestone', name: 'Milestone' },
};

export default projectTaskCategoryTypes;
